import type { ActiveFiltersState } from '../../../shared/types';

export type FiltersMap = Record<string, string[]>;

export const buildFiltersMap = (filters: ActiveFiltersState[]): FiltersMap =>
  Object.fromEntries(
    filters.map((f) => [
      f.value,
      f.options.map((o: { value: string }) => o.value),
    ])
  );
